module.exports = __webpack_public_path__ + "static/media/thailand-flag.e69e10df.png";